import { Pipe, PipeTransform } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';

@Pipe({
  name: 'responseState'
})
export class StatePipePipe implements PipeTransform {

  // TODO Implement this instead of custom dict
  stateDict = {};

  public constructor(private configService: ConfigService) { }

  transform(value: any, ...args: any[]): any {
    return null;
  }

  loadCustomStateDict() {
    this.stateDict = this.configService.company_info.custom_state_dictionary;
  }

}
